export default __webpack_public_path__ + "static/media/arrow-right-white.71c305c8.svg";